angular.module('olivioConfiguratorApp')
	.controller('CheckoutCtrl', function ($http, $rootScope, $scope, Model, Storage, Data, DescData, env) {
		//console.log('init CheckoutCtrl');

    $scope.OLIVIO = OLIVIO;
    $scope.model = Model.model;
    $scope.data = Data;
    $scope.descData = DescData;
    $scope.configurationToken = false;

    $scope.wood = $scope.data.getColorSelectOption($scope.model.design.colorIds.mast).wood;
    $scope.mast168 = false; // FIXME mastdurchmesser

    $scope.goboCount = 0;
    if(Model.goboAllowed()) {
      for (var i = 0; i<Model.model.gobo.individual.length; i++) {
        if(Model.model.gobo.individual[i])
          $scope.goboCount++;
      }
    }
    $scope.haveGobo = ($scope.goboCount > 0);

    $scope.lumcountPiccolo = 0;
    $scope.lumcountNonPiccolo = 0;
    for(var i=0;i<Model.model.design.individualHeads.length; i++) {
      if(!Model.model.gobo.individual[i] && OLIVIO.LUM_PICCOLO === Model.model.design.individualHeads[i]) {
        $scope.lumcountPiccolo++;
      } else if(Model.model.gobo.individual[i] || Model.model.design.individualHeads[i]) {
        $scope.lumcountNonPiccolo++;
      } else {
        console.error('invalid lum '+i+': ',Model.model.design.individualHeads[i], Model.model.gobo.individual[i]);
      }
    }
    if($scope.lumcountNonPiccolo+$scope.lumcountPiccolo > Model.model.design.lumcount) {
      console.error('More individualHeads than lumconunt',Model.model.design.lumcount, '<', $scope.lumcountNonPiccolo,'+',$scope.lumcountPiccolo,':', Model.model.design.individualHeads, Model.model.gobo.individual);
    }

    if($scope.model.userOptions.displayPrices) {
      $scope.priceSum = $scope.data.getPriceSum($scope.model, $scope.lumcountNonPiccolo, $scope.lumcountPiccolo);
      $scope.priceSurchargeMastColor = $scope.data.getPriceSurchargeMastColor($scope.model, $scope.lumcountNonPiccolo, $scope.lumcountPiccolo);
      $scope.priceSurchargeLumColor = $scope.data.getPriceSurchargeLumColor($scope.model, $scope.lumcountNonPiccolo, $scope.lumcountPiccolo);
      console.log('prices', {
        priceSum: $scope.priceSum,
        priceSurchargeMastColor: $scope.priceSurchargeMastColor,
        priceSurchargeLumColor: $scope.priceSurchargeLumColor
      });
      $scope.showSurchargeMastColor = isNaN($scope.priceSurchargeMastColor) || $scope.priceSurchargeMastColor;
      $scope.showSurchargeLumColor = isNaN($scope.priceSurchargeLumColor) || $scope.priceSurchargeLumColor;
    }

		Storage.saveConfigurationToServer(function (token) {
			$scope.configurationToken = token;
		}, function () {
      console.error('Server not available to save configuration');
			// TODO: User feedback! 'Server not available to save configuration'
		});

		// get range for ngRepeat
		$scope.lumRange = function () {
			return new Array($scope.model.design.lumcount);
		};

		$scope.downloadPdf = function () {
			Storage.saveStateToServer(function (token) {
				var url = env.pdfGeneratorUrl;
				url = url.replace(':token', token);
				url = url.replace(':lang', $scope.model.locale);
				console.log('Initiating PDF download', url);
				location.href = url;
			}, function () {
				// TODO: User feedback! "Server not available to generate pdf"
        console.error('Server not available to generate pdf', env.pdfGeneratorUrl, url);
			});
		};


		function redirectToDxfGenerator(svg, fileNameSuffix) {
			fileNameSuffix = fileNameSuffix || 'side';
			var form = document.createElement('form');
			form.setAttribute('method', 'post');
			form.setAttribute('action', env.dxfGeneratorUrl.replace(':fileNameSuffix', fileNameSuffix));
			form.setAttribute('target', 'dxfgeneratorpopup');

			var hiddenField = document.createElement('input');
			hiddenField.setAttribute('type', 'hidden');
			hiddenField.setAttribute('name', 'svg');
			hiddenField.setAttribute('value', svg);
			form.appendChild(hiddenField);
			document.body.appendChild(form);

			window.open('', 'dxfgeneratorpopup');
			form.submit();
		}

		// Generate zip with dxf-files from submitted svgs
		function redirectToDxfGeneratorZip(svgs) {
			var form = document.createElement('form');
			form.setAttribute('method', 'post');
			form.setAttribute('action', env.dxfGeneratorZipUrl);
			form.setAttribute('target', 'dxfgeneratorpopup');

			//add svgs
			for (var i=0;i < svgs.length;i++) {
				var hiddenField = document.createElement('input');
				hiddenField.setAttribute('type', 'hidden');
				hiddenField.setAttribute('name', 'svg['+i+']');
				hiddenField.setAttribute('value', svgs[i]);
				form.appendChild(hiddenField);
			}
			document.body.appendChild(form);
			//console.log(form);
			window.open('', 'dxfgeneratorpopup');
			form.submit();
		}

		$scope.downloadDxfSide = function () {
			redirectToDxfGenerator($scope.poleSide.draw.exportSvg(), 'side');
		};

		$scope.downloadDxfTop = function () {
			redirectToDxfGenerator($scope.poleTop.draw.exportSvg(), 'top');
		};
		$scope.downloadDxfZip = function () {
			redirectToDxfGeneratorZip([$scope.poleSide.draw.exportSvg(), $scope.poleTop.draw.exportSvg()]);
		};
		$scope.downloadLdtZip = function () {
			var itemNumbers = [];
			for (var i = 0; i < $scope.model.design.lumcount; i++) {
				var sx = encodeURIComponent($scope.data.getSXNumberForArticle($scope.model, i));
				if (itemNumbers.indexOf(sx) === -1) {
					itemNumbers.push(sx);
				}
			}
			location.href = env.ldtFilesDownloadUrl + itemNumbers.join(',');
		};

		$scope.print = function () {
			window.print();
		};


		$scope.scrollToSheetOne = function () {
			//console.log('scrollToSheetOne');
			console.log($scope.lumRange);
			document.getElementById('summary').scrollIntoView(true);
		};

		$scope.scrollToSheetTwo = function () {
			//console.log('scrollToSheetTwo');
			document.getElementById('pageTwo').scrollIntoView(true);
		};

		$scope.personalize = function () {
			//console.log('personalize');
			$scope.model.person.entered = true;
			window.setTimeout(10, function () {
				document.getElementById('personalDetails').setStyle('height=210;');
				document.getElementById('pageOne').getComputedStyle();
			});
		};

		if (!$scope.poleTop) {
			(function () {
				// create svg canvas
				var element = angular.element(document.getElementById('sheetTop'));
				var draw = SVG('sheetTop').size(element.width(), element.height());
				draw.viewbox(0, 0, 1500, 1500);

				// render pole
				$scope.poleTop = new OLIVIO.PoleTop(draw, null, null);
			}());
		}

		if (!$scope.poleSide) {
			(function () {
				// create svg canvas
				var element = angular.element(document.getElementById('sheetSide'));
				var draw = SVG('sheetSide').size(element.width(), element.height());
				var viewBoxWidthSide = 3980 * ((element.width()) / element.height());
				draw.viewbox(0, 0, viewBoxWidthSide, 3980 + 110);

				// render pole
				$scope.poleSide = new OLIVIO.PoleSide(draw, null, null);
			}());
		}

		OLIVIO.cmodel.initFromAngularModel(Model.model, Data);
    OLIVIO.cmodel.poleSelected = false;
    OLIVIO.cmodel.setSingleLumSelected(-1); // sets pub.firstAndLastLumSelected = false;
		$scope.poleTop.updateLums();
		$scope.poleTop.repaint();
		$scope.poleSide.updateHeight();
		$scope.poleSide.updateLumsForceRotation();
		$scope.poleSide.repaint();

	});
